<it-dialog
    [header]="inputs.header"
    [showCancelButton]="true"
    (cancelled)="cancel()"
    (accepted)="accept()"
>
    <it-text>{{ inputs.message }}</it-text>
</it-dialog>
